import * as React from 'react'
import cc from 'classcat'
import Star from '../Icons/Star'

import s from './styles.module.css'

const repeat = (n, fn) => Array.from(Array(n)).map(fn)

const Rating = ({ rating }) => (
  <div className={s.stars}>
    {repeat(5, (_, idx) => (
      <Star
        key={`star-${idx}`}
        className={cc([
          s.star,
          {
            [s.inactive]: rating <= idx
          }
        ])}
      />
    ))}
  </div>
)

export default class Testimonial extends React.Component {
  render() {
    const { title, author, content, rating, className } = this.props

    return (
      <div className={cc([s.testimonial, className])}>
        <div className={s.header}>
          <Rating rating={rating} />
        </div>
        <p className={s.content}>{content}</p>
        <p className={s.author}>{author}</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Testimonial/index.js